import * as React from "react"

import ProductCard from "./ProductCard"
import { StoreContext } from "../../context/store-context"
import {sortAvailableProducts} from "../../utils/utils"

// To optimize LCP we mark the first product card as eager so the image gets loaded faster
const ProductListing = ({ products = [], limit }) => {
  const { client } = React.useContext(StoreContext);

  const [productsLatest, setProductsLatest] = React.useState(null);

  const checkAvailablity = React.useCallback((prods) => {
    const ids = prods.map(x => x.shopifyId);

    client.product.fetchMultiple(ids).then((fresh_products) => {      
      if (fresh_products && fresh_products.length) {        
        setProductsLatest(fresh_products);
      }
    });
  }, [client.product]);


  React.useEffect(() => {
    if (products && products.length) {
      checkAvailablity(products);
    }
    
  }, [checkAvailablity, products]);
  
  
  if (limit) {
    products = products.slice(0, limit);
  }

  // sort so available products at front
  products = sortAvailableProducts(products);

  if (!products.length) {
    return <div className=" text-center text-2xl mx-auto my-20">Nothing currently for sale in this section</div>
  }
  
  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-5 lg:gap-5">
      {products.map((p, index) => (
        <ProductCard productsLatest={productsLatest} product={p} key={p.id} eager={index === 0} />
      ))}
    </div>
  )
};

export default ProductListing
